<div class="containerdocument">
  <div *ngIf="isDetailsPage('homepage')">
    <div class="col-md-12 px-0" style="margin-top: 4%;">
      <div class="row documentForm" [formGroup]="documentform">
        <mat-form-field class="col-2" appearance="outline">
          <mat-label>Document Type</mat-label>
          <mat-select formControlName="documenttype" [(ngModel)]="valuedoctype"
            (selectionChange)="onDocumentSelect($event.value,documentform.value)">
            <mat-select-filter [placeholder]="'Filter'" [displayMember]="'lookup_code'" [array]="documenttypedropdown"
              (filteredReturn)="documenttypedropdown1 = $event"></mat-select-filter>
            <!-- <input (keyup)="onKey($event)" type="text" matInput> -->
            <mat-option *ngFor="let i of documenttypedropdown1" [value]="i.lookup_code">{{i.lookup_code}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-3" appearance="outline">
          <mat-label>Document Visibility</mat-label>
          <mat-select formControlName="visibility" [(ngModel)]="visibityvaluefromdocumenttype"
            (selectionChange)="onViewValueChange(documentform.value)">
            <mat-select-filter [placeholder]="'Filter'" [displayMember]="'visibility'" [array]="visibilityList"
              (filteredReturn)="visibilityList1 =$event"></mat-select-filter>
            <mat-option *ngFor="let i of visibilityList1" [value]="i.visibility">{{i.visibility}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button role="button" class="schBtn" (click)="opendefinedocpop()">Manage Doc Type</button>
        <button role="button" class="schBtn1" (click)="openuploaddocpop()">Upload Doc</button>

      </div>

      <div class="row position-relative">
        <div class="col-md-12 no-border" style="border: solid 2px #eee;">
          <ag-grid-angular [defaultColDef]="defaultColDef" style="height: 26rem;margin-left: -1%;"
            class="ag-theme-alpine col-md-12" [rowData]="rowData" [columnDefs]="columnDefs"
            [overlayLoadingTemplate]="overlayLoadingTemplate" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
            [rowSelection]="rowSelection" [enableCellTextSelection]="'true'" (gridReady)="onGridReady($event)"
            [rowHeight]="rowHeight" [paginationAutoPageSize]="true" [pagination]="true"
            [frameworkComponents]="frameworkComponents" (cellClicked)="onCellClicked($event)"
            [tooltipShowDelay]="tooltipShowDelay" [suppressRowHoverHighlight]="true" [animateRows]="true">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isDetailsPage('definedoctype')">
    <div class="row mb-1">
      <div class="col-md-12">
        <nav aria-label="breadcrumb historyTableCss">
          <ol class="breadcrumb bg-white">
            <li class="breadcrumb-item cursor-pointer fBread" (click)="onBack($event)">
              Manage
            </li>
            <li class="breadcrumb-item cursor-pointer fBread" aria-current="page">
              Manage Doc Type
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-definedoctype></app-definedoctype>
      </div>
    </div>
  </div>

  <div *ngIf="isDetailsPage('uploaddoc')">
    <div class="row mb-1">
      <div class="col-md-12">
        <nav aria-label="breadcrumb historyTableCss">
          <ol class="breadcrumb bg-white">
            <li class="breadcrumb-item cursor-pointer fBread" (click)="onBack($event)">
              Manage
            </li>
            <li class="breadcrumb-item cursor-pointer fBread" aria-current="page">
              Upload Doc
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-uploaddoc (newItemEvent)="onbackchild($event)"></app-uploaddoc>
      </div>
    </div>
  </div>


</div>
